<template>
  <portal to="destination">
    <div class="dimmed">
      <div class="modal" :class="{active: loaded}">
        <div class="caution">{{ $t("CautionPage.CAUTION") }}</div>
        <section class="caution-01">
          <img
            srcset="./mobile/caution_00.png 240w, ./pc/caution_00.png 720w"
            src="./pc/caution_00.png"
            alt
          />
          <span>
            {{ $t("CautionPage.needItem") }}
            <br />
            {{ $t("CautionPage.children") }}
          </span>
          <br />
        </section>
        <section class="section">
          <img
            srcset="./mobile/caution_01.png 240w, ./pc/caution_01.png 720w"
            src="./pc/caution_01.png"
            alt
          />
          <span>{{ $t("CautionPage.mat") }}</span>
        </section>
        <section class="section">
          <img
            srcset="./mobile/caution_02.png 240w, ./pc/caution_02.png 720w"
            src="./pc/caution_02.png"
            alt
          />
          <span>{{ $t("CautionPage.doNotPutHeavyThing") }}</span>
        </section>
        <section class="section">
          <img
            srcset="./mobile/caution_03.png 240w, ./pc/caution_03.png 720w"
            src="./pc/caution_03.png"
            alt
          />
          <span>{{ $t("CautionPage.doNotThrow") }}</span>
        </section>
        <section class="section">
          <img
            srcset="./mobile/caution_05.png 240w, ./pc/caution_05.png 720w"
            src="./pc/caution_05.png"
            alt
          />
          <span>{{ $t("CautionPage.stayAwayFlame") }}</span>
        </section>
        <section class="section">
          <img
            srcset="./mobile/caution_06.png 240w, ./pc/caution_06.png 720w"
            src="./pc/caution_06.png"
            alt
          />
          <span>{{ $t("CautionPage.stayAwayWater") }}</span>
        </section>
        <div class="warning">
          <div>
            <span>{{ $t("CautionPage.mayDamaged") }}</span>
          </div>
          <div>
            <span>{{ $t("CautionPage.companyDoestResponsible") }}</span>
          </div>
          <div>
            <span>{{ $t("CautionPage.cannotBeReturned") }}</span>
          </div>

        </div>
        <div class="txt-center">
          <a class="button" @click.prevent="onOk">{{ $t("CautionPage.understand") }}</a>
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
import OnLoadImage from "../../mixin/OnLoadImage";
export default {
  mixins: [OnLoadImage],
  created() {
    this.on;
  },
  data() {
    return {
      loaded: false
    };
  },
  props: {
    onOk: {
      type: Function,
      default: () => {}
    }
  },

  async mounted() {
    document.body.style.overflowY = "auto";
    document.body.style.position = "fixed";
    await this.loadImages([
      require("./mobile/caution_00.png"),
      require("./mobile/caution_01.png"),
      require("./mobile/caution_02.png"),
      require("./mobile/caution_03.png"),
      require("./mobile/caution_05.png"),
      require("./mobile/caution_06.png")
    ]);
    this.loaded = true;
  },
  destroyed() {
    document.body.style.position = "";
    document.body.style.overflowY = "";
  },
  methods: {}
};
</script>

<style scoped>
.dimmed {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  text-align: left;
}

.modal {
  margin: auto;
  width: 320px;
  background-color: white;
  color: black;
  border-radius: 30px;
  margin-top: 54px;

  padding: 30px 40px;
  box-sizing: border-box;
  margin-bottom: 108px;
  opacity: 0;
  transition: opacity 0.3s;
}
.modal.active {
  opacity: 1;
}
.modal span {
  font-family: "SamsungOne";
  font-weight: 600;
  text-transform: uppercase;
}
.modal .caution {
  text-align: center;
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: 700;
}
.caution-01 {
  position: relative;
}
.caution-01 img {
  width: 100%;
}
.caution-01 span {
  position: absolute;
  left: 128px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  margin-right: 10px;
}
.section {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.section img {
  width: 104px;
}
.section span {
  margin-left: 24px;
  font-size: 10px;
}
.warning {
  margin-top: 15px;
  margin-bottom: 30px;
  font-size: 10px;
}
/* .warning span::before {
  content: "*";
  font-size: 10px;
} */
.button {
  font-size: 12px;
  font-weight: 700;
  padding: 9px 0;
  width: 208px;
  background-color: #ff5440;
  border-radius: 15px;
  color: #f5f5f5;
  text-align: center;
  margin: auto;
  cursor: pointer;
  display: inline-block;
}
@media (min-width: 1024px) {
  .modal {
    margin-top: 124px;
    width: 790px;
    padding: 60px 125px;
    position: relative;
    /* padding-bottom: 150px; */

    /* margin-bottom: 200px; */
  }
  .modal .caution {
    font-size: 36px;
  }
  .caution-01 span {
    left: 306px;
    font-size: 16px;
  }
  .section {
    margin-top: 30px;
  }
  .section img {
    width: 232px;
  }
  .section span {
    font-size: 16px;
    margin-left: 75px;
    margin-right: 10px;
  }
  .warning {
    margin-top: 34px;
    margin-bottom: 92px;
    font-size: 16px;
  }
  .button {
    width: 100%;
    padding-top: 27px;
    padding-bottom: 28px;
    border-radius: 40px;
    font-size: 24px;
    line-height: 0.87;
    /* position: absolute; */
    width: 584px;

    transform: translateX(-20px);
    cursor: pointer;
  }
}
</style>
